<template>
  <v-layout>
    <v-flex xs12>
    <ServerIterator 
      v-if="reset"
      :items="items" 
      title="Workflows" 
      :displayItem="displayComponent" 
      :displayArgs="curMsg"
      :changedArgs.sync="changedArgs"
      :total='total'
      :currentPage.sync="currentPage"
      >
      <template v-slot:topbar>
        <v-toolbar id="topbar"   dense>
          <v-toolbar-title>Workflows</v-toolbar-title>
          <v-spacer></v-spacer>
          <div style="padding-right: 10px;">{{category}}</div>
          <v-menu  v-if="categories != null && categories.length > 1" offset-y>
            <template v-slot:activator="{on, attrs}" :close-on-click="closeOnClick">
              <v-icon class="msg-icon" v-bind="attrs" v-on="on">mdi-sort</v-icon>
            </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in categories"
                  :key="index"
                >
                  <v-list-item-title @click="setCategory(item)">{{item}}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
        </v-toolbar>
      </template>
    </ServerIterator>
    </v-flex>
  </v-layout>
</template>

<script>
import itemDisplay from './DisplayOne.vue'
import ServerIterator from '@/../../coreui/components/ServerIterator.vue'
import { sync } from "vuex-pathify"
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  props: {
    org: {
      type: String,
      required: false,
      default: 'org'
    },
    module: {
      type: String,
      required: false,
      default: null
    },
    ids: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    ServerIterator,
    itemDisplay
  },
  data () {
    return {
      reset: true,
      currentPage: {page: 1, items: 0},
      total: 0,
      items:[],
      pipeline: [],
      matchAnd: [],
      displayComponent: itemDisplay,
      closeOnClick: true,
      closeSend: false,
      matchAnd: [],
      categories: [],
      category: null,
      show: 'All',
      read: 'All',
      curMsg: {op: 'new', 'item': {}},
      changedArgs: null
    }
  },
  computed: {
    origLoggedinUser: sync("login/origLoggedinUser"),
    origLoggedinOrg: sync('login/origLoggedinOrg')
  },
  watch: {
    currentPage: {
      deep: true,
      async handler (val) {
        await this.getWorkflows((val.page - 1) * val.items, val.items)
      }
    },
  },
  methods: {
    setCategory(val) {
      this.category= val
      this.redraw()
    },
    setRead(val) {
      this.show = val
      this.redraw()
    },
    redraw () {
      this.closeSend = {'op': 'close'}
      this.reset = false
      this.$nextTick(() => {this.reset = true})
    },
    async getWorkflows (skip, limit) {
      let res
      console.log('ids: ', this.ids)
      res = await axiosInstances.loginServer.get('/dt/v1/auth_workflows?return=category')
      if (res == null || res.data == null) {
        console.log('Returning')
        return
      }
      let cats = res.data.map(i => {return i.category})
      this.categories = ['All', ...new Set(cats)]
      res = null
      if (this.origLoggedinUser.role == 'super') {
        this.pipeline = []
        if (this.ids.length != 0) {
          this.pipeline = [
            {"$addFields": { "strId": {"$toString": "$_id"}}},
            {"$match": {"$expr": { "$in": ["$strId", this.ids]}}}
          ]
        }
        if (this.module != null) {
          let modid = await axiosInstances.loginServer.get('/dt/v1/sup_modules?name=' + this.module)
          if (modid != null && modid.data != null) this.pipeline.push({
            "$match": {"$expr": {"$in": [modid.data[0]._id, "$module"]}}
          })
        }
        if (this.category != 'All') this.pipeline.push({
          '$match' : {"category": { "$eq" : this.category}}
        })
        this.pipeline.push({
          "\$sort": {
            "pos" : 1
          }
        })
        this.pipeline.push({
            $facet: {
              pages: [
                { $skip: skip },
                { $limit: limit }
              ],
              total: [{ $count: "count" }],
            },
          })
        let url = '/misc/dbops?c=auth_workflows&op=pipe'
        res = await axiosInstances.loginServer.post(url, this.pipeline)
      } else {
        // pipeline doesn't work on auth server for regular users
        res = {}
        res.data = []
        let wfs = await axiosInstances.loginServer.get('/dt/v1/auth_workflows')
        let z = {}
        z.pages = wfs == null || wfs.data == null ? [] : wfs.data
        if (this.ids.length != 0) {
          let filtered
          filtered = z.pages.filter((i) => {return this.ids.includes(i._id)})
          if (this.module != null) {
            let modid = await axiosInstances.loginServer.get('/dt/v1/sup_modules?return=code&name=' + this.module)
            if (modid != null && modid.data != null) {
              filtered = filtered.filter((i) => {return i.module.includes(modid.data[0]._id)})
            }
          }
          z.pages = filtered
        }
        z.total = []
        z.total.push({count: z.pages.length})
        res.data.push(z)
      }
      if (res != null && res.data != null && res.data[0].total.length > 0) {
        this.items = res.data[0].pages
        this.total = res.data[0].total[0].count
      } else {
        this.items = []
        this.total = 0
      }
    },
  },
  mounted () {
    this.total = 0
    this.getWorkflows(0, 10)
    this.category = 'All'
  }
}
</script>
<style scoped>
.topbar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 6em;
  z-index: 2;
}
.msg-icon {
  margin-right: 20px;
}
</style>